import { HttpErrorResponse } from '@angular/common/http';

/**
 * Map an HTTP error to a safe, whitelisted user-facing message.
 *
 * Pass per-call copy for the statuses that matter; any other status — and any
 * non-HTTP error — falls back to `fallback`. The raw backend message/body is
 * never surfaced, so no internal detail or PII leaks to the UI
 * (LoggingAndErrorHandlingGuidelines §9.2). Replaces the near-identical
 * per-dialog `mapError` helpers (CodingStyleGuidelines §7.2).
 */
export function mapHttpError(
  err: unknown,
  messages: Partial<Record<number, string>>,
  fallback = 'Save failed — please retry.',
): string {
  if (err instanceof HttpErrorResponse) {
    const message = messages[err.status];
    if (message) return message;
  }
  return fallback;
}
